import React from "react";

// Quarterly contractor check-in report form (rendered inside the Activity Log
// modal when the Quarterly category is selected).
const QuarterlyCheckInForm = ({ quarterlyForm, setQuarterlyForm, onSubmit, saving }) => (
    <div className="quarterly-form">
        <div className="quarterly-form-header">
            <h4>Contractor Check-In Report</h4>
            <select
                value={quarterlyForm.quarter}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, quarter: e.target.value }))}
                className="quarter-select"
            >
                <option value="Q1">Q1</option>
                <option value="Q2">Q2</option>
                <option value="Q3">Q3</option>
                <option value="Q4">Q4</option>
            </select>
        </div>

        <div className="quarterly-section">
            <h5>Operational Feedback</h5>
            <label>How would the contractor rate communication in general?</label>
            <textarea rows="2" value={quarterlyForm.communicationRating}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, communicationRating: e.target.value }))} />
            <label>Are scheduling lead times meeting expectations?</label>
            <textarea rows="2" value={quarterlyForm.schedulingLeadTimes}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, schedulingLeadTimes: e.target.value }))} />
            <label>Are there any concerns regarding referrals or workflow?</label>
            <textarea rows="2" value={quarterlyForm.referralConcerns}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, referralConcerns: e.target.value }))} />
            <label>Have there been any recurring patient compliance concerns?</label>
            <textarea rows="2" value={quarterlyForm.patientComplianceConcerns}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, patientComplianceConcerns: e.target.value }))} />
        </div>

        <div className="quarterly-section">
            <h5>Relationship &amp; Partnership Review</h5>
            <label>What is currently working well in the partnership?</label>
            <textarea rows="2" value={quarterlyForm.workingWell}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, workingWell: e.target.value }))} />
            <label>What areas could be improved?</label>
            <textarea rows="2" value={quarterlyForm.areasToImprove}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, areasToImprove: e.target.value }))} />
            <label>Are there any support tools or resources needed?</label>
            <textarea rows="2" value={quarterlyForm.supportNeeded}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, supportNeeded: e.target.value }))} />
        </div>

        <div className="quarterly-section">
            <h5>Performance &amp; Growth Opportunities</h5>
            <label>Any concerns regarding billing, records, or communication turnaround times?</label>
            <textarea rows="2" value={quarterlyForm.billingConcerns}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, billingConcerns: e.target.value }))} />
            <label>Are there opportunities to strengthen collaboration?</label>
            <textarea rows="2" value={quarterlyForm.collaborationOpportunities}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, collaborationOpportunities: e.target.value }))} />
        </div>

        <div className="quarterly-section">
            <h5>Executive Summary</h5>
            <textarea rows="3" value={quarterlyForm.executiveSummary}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, executiveSummary: e.target.value }))}
                placeholder="Overall summary of the partnership status..." />

            <label>Overall Partnership Rating *</label>
            <div className="rating-options">
                {['Excellent', 'Strong', 'Satisfactory', 'Needs Improvement'].map(rating => (
                    <button
                        key={rating}
                        className={`rating-btn ${quarterlyForm.overallRating === rating ? 'selected' : ''} rating-${rating.toLowerCase().replace(' ', '-')}`}
                        onClick={() => setQuarterlyForm(prev => ({ ...prev, overallRating: rating }))}
                        type="button"
                    >{rating}</button>
                ))}
            </div>

            <label>Follow-Up Action Items</label>
            <textarea rows="2" value={quarterlyForm.followUpItems}
                onChange={(e) => setQuarterlyForm(prev => ({ ...prev, followUpItems: e.target.value }))}
                placeholder="Action items for next quarter..." />
        </div>

        <button
            className="add-note-btn quarterly-submit-btn"
            onClick={onSubmit}
            disabled={saving}
        >
            {saving ? "Saving..." : "📊 Save Quarterly Check-In"}
        </button>
    </div>
);

export default QuarterlyCheckInForm;
